import React from 'react';
import { aftercareInstructions } from '../mock';
import { AlertCircle } from 'lucide-react';

const Aftercare = () => {
  return (
    <div className="min-h-screen bg-zinc-950 py-20 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-black mb-4 text-zinc-100">AFTERCARE</h1>
          <p className="text-zinc-400 text-lg">
            Proper aftercare is essential for healthy healing. Follow these instructions carefully.
          </p>
        </div>

        <div className="space-y-8">
          {aftercareInstructions.map((section, index) => (
            <div key={index} className="bg-zinc-900 border border-zinc-800 overflow-hidden">
              <div className="bg-red-900 p-6">
                <h2 className="text-2xl font-black text-white uppercase tracking-wide">{section.title}</h2>
              </div>
              <div className="p-6">
                <ul className="space-y-3">
                  {section.instructions.map((instruction, i) => (
                    <li key={i} className="flex items-start">
                      <span className="text-red-800 mr-3 mt-1 flex-shrink-0">●</span>
                      <span className="text-zinc-300 leading-relaxed">{instruction}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-red-950 border-2 border-red-900 p-8">
          <div className="flex items-start gap-4">
            <AlertCircle className="h-8 w-8 text-red-500 flex-shrink-0 mt-1" />
            <div>
              <h3 className="text-xl font-black text-zinc-100 mb-3">IMPORTANT REMINDER</h3>
              <p className="text-zinc-300 leading-relaxed mb-4">
                Every body heals differently. If you have any concerns about your piercing, don't hesitate to reach out.
              </p>
              <p className="text-zinc-300 leading-relaxed">
                Registered clients can use our live chat system for quick questions and support throughout your healing journey.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Aftercare;